// extracted by mini-css-extract-plugin
export default {"page-content-container":"PageContent_page-content-container__B4adk","page-content":"PageContent_page-content__Mg9Bg"};